// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#tianai-captcha.tianai-captcha-rotate .rotate-img-div {\n  height: 100%;\n  /*position: absolute;*/\n  text-align: center;\n}\n#tianai-captcha.tianai-captcha-rotate .rotate-img-div img {\n  height: 100%;\n  -webkit-transform: rotate(0deg);\n      -ms-transform: rotate(0deg);\n          transform: rotate(0deg);\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
